import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateTimeUtilsService {

  constructor() { }

  extractDate(datetime: string | undefined): string {
    if (datetime == null) {
      return '';
    }
    // Format is "YYYY-MM-DD HH:mm:ss" after processing
    return datetime.split('T')[0];
  }

  extractTime(datetime: string | undefined): string {
    if (datetime == null) {
      return '';
    }
    // Format is "YYYY-MM-DDTHH:mm:ssZ" - extract time and remove the Z
    let time = datetime.split('T')[1];
    if (time != null) {
      time = time.replace('Z', '');
    }
    return time;
  }
}
